import { devFreeze } from "@rpldy/shared";
const defaults = devFreeze({
  allowRegisterNonExistent: true,
  canAddEvents: true,
  canRemoveEvents: true,
  collectStats: false
});
export default defaults;